/* --------------------------------------------  User Registration Page Validation ---------------------------------------------------*/

/* Business Name */

export const validateBusinessName = (value) => {
  if (!value.trim()) {
    return "Business Name is required.";
  }

  const businessNameRegex = /^[a-zA-Z0-9\s]{3,}$/;
  if (!businessNameRegex.test(value)) {
    return "Business Name must be at least 3 characters and contain only letters, numbers, and spaces.";
  }

  return ""; // No error
};

/* Business Category */

export const validateBusinessCategory = (value) => {
  if (!value) {
    return "Business Category is required.";
  }
  return ""; // No error
};


/* Business Category Others */

export const validateBusinessNameOthers = (value) => {
  if (!value.trim()) {
    return "Custom Business Name  is required.";
  }

  const customBusinessNameRegex = /^[a-zA-Z0-9\s]{3,}$/;
  if (!customBusinessNameRegex.test(value)) {
    return "Custom Business Name must be at least 3 characters and contain only letters, numbers, and spaces.";
  }

  return ""; // No error
};

/*  Owner Name  */
export const validateOwnerName = (value) => {
  if (!value.trim()) {
    return "Name is required.";
  }
  const ownerNameRegex = /^[a-zA-Z ]{3,}$/;

  if (!ownerNameRegex.test(value)) {
    return "Name must be at least 3 characters long and contain only letters and spaces.";
  }

  return ""; // No error
};


export const validateName = (name) => {
  const trimmedName = name.trim(); // Remove leading/trailing spaces
  const regex = /^[a-zA-Z]+(?: [a-zA-Z]+)*$/; // Ensures only letters & single spaces

  if (!trimmedName) {
    return "Name is required.";
  }

  if (trimmedName.length < 2) {
    return "Name must be at least 2 characters long.";
  }

  if (trimmedName.length > 50) {
    return "Name must not exceed 50 characters.";
  }

  if (!regex.test(trimmedName)) {
    return "Name can only contain letters and single spaces. No numbers or special characters allowed.";
  }

  return ""; // Valid name
};



/* Mobile Number */
export const validateMobileNumber = (value) => {
  if (!value) {
    return "Mobile number is required.";
  }

  if (!/^\d+$/.test(value)) {
    return "Mobile number must contain only digits.";
  }

  if (value.length !== 10) {
    return "Mobile number must be exactly 10 digits.";
  }

  if (!/^[6-9]\d{9}$/.test(value)) {
    return "Enter a valid 10-digit mobile number.";
  }

  return ""; // No error
};

/* Email */
export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Standard email regex pattern
  if (!email) {
    return "Email is required.";
  }
  if (!regex.test(email)) {
    return "Enter a valid email address.";
  }
  return "";
};


/* Password */
export const validatePassword = (password) => {
  if (!password) {
    return "Password is required.";
  }

  if (password.length < 8 || password.length > 20 ||
      !/[A-Z]/.test(password) || !/[a-z]/.test(password) ||
      !/[0-9]/.test(password) || !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return "Password must be 8-20 characters long and include uppercase, lowercase, number, and a special character.";
  }

  return ""; // If all checks pass, return an empty string (no errors)
};

/* Otp */

export const validateOtp = (otp) => {
  if (!otp) {
    return "OTP is required.";
  }

  if (!/^\d{6}$/.test(otp)) {
    return "OTP must be exactly 6 digits.";
  }

  return ""; // No error (OTP is valid)
};

/* Bank Account Number */

export const validateBankAccountNumber = (accountNumber) => {
  const trimmedAccountNumber = accountNumber.trim(); // Remove leading/trailing spaces
  const regex = /^\d{9,18}$/; // Only digits, length 9-18

  if (!trimmedAccountNumber) {
    return "Bank account number is required.";
  }

  if (!/^\d+$/.test(trimmedAccountNumber)) {
    return "Bank account number must contain only digits.";
  }

  if (trimmedAccountNumber.length < 9 || trimmedAccountNumber.length > 18) {
    return "Bank account number must be between 9 and 18 digits.";
  }

  return ""; // No errors
};


/* IFSC Code*/ 
export const validateIFSCCode = (ifscCode) => {
  const trimmedIfscCode = ifscCode.trim(); // Remove leading/trailing spaces
  const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/; // IFSC pattern

  if (!trimmedIfscCode) {
    return "IFSC code is required.";
  }

  if (trimmedIfscCode.length !== 11) {
    return "IFSC code must be exactly 11 characters long.";
  }

  if (!/^[A-Z]{4}/.test(trimmedIfscCode)) {
    return "First 4 characters must be uppercase letters (bank code).";
  }

  if (trimmedIfscCode[4] !== "0") {
    return "The 5th character must be '0' (reserved for future use).";
  }

  if (!/^[A-Z0-9]{6}$/.test(trimmedIfscCode.slice(5))) {
    return "Last 6 characters must be uppercase letters or digits (branch code).";
  }

  return ""; // No errors (Valid IFSC)
};



// Dropdown Required Validation
export const validateDropdown = (fieldName = 'The Field', value) => {
  if (!value) {
    return `${fieldName} is Required`;
  }
  return "";
};

/*  Required field Validation */

export const validateRequired = (value) => {
  if (!value) {
    return "Required.";
  }
  return "";
};

/*  Validation for title and message (should include letters, numbers, and special characters) */

export const validateText = (text) => {
  const regex = /^[a-zA-Z0-9_!@#$%^&*(),.?":{}|<> ]*$/;
  if (!text) {
    return "Required Field";
  }
  if (!regex.test(text)) {
    return "Must include letters, numbers, and special characters.";
  }
  return "";
};



export const validateNameOnly = (name) => {

  const regex = /^[a-zA-Z ]*$/;

  if (!name) {
    return "Name is required.";
  }

  if (!/[a-zA-Z]/.test(name)) {
    return "Name must contain at least one letter.";
  }

  if (!regex.test(name)) {
    return "Name must contain only letters and spaces.";
  }

  return ""; 
};


export const validateNumbers = (value) => {
  const regex = /^[0-9@#$%^&*().+-]+$/;

  if (!value) {
    return "Required.";
  }
  if (!regex.test(value)) {
    return "Must include only numbers, symbols, or dots.";
  }
  return "";
}


export const validateAadharNumber = (aadhar) => {
  const regex = /^\d{4}-\d{4}-\d{4}$/; 

  if (!aadhar) {
    return "Aadhar number is required.";
  }

  if (!regex.test(aadhar)) {
    return "Aadhar number must be in the format xxxx-xxxx-xxxx.";
  }

  return ""; // No errors
};

/* PAN Card validation  */

export const validatePanCardNumber = (pan) => {
  const trimmedPan = pan.trim(); // Remove leading/trailing spaces
  const regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN format

  if (!trimmedPan) {
    return "PAN card number is required.";
  }

  if (trimmedPan.length !== 10) {
    return "PAN card number must be exactly 10 characters long.";
  }

  if (!regex.test(trimmedPan)) {
    return "PAN card number must be in the format AAAAA9999A (5 letters, 4 digits, 1 letter).";
  }

  const validCategories = ["P", "C", "H", "F", "A", "T", "B", "L", "J", "G"];
  if (!validCategories.includes(trimmedPan[3])) {
    return `Invalid PAN type. The 4th character should be one of ${validCategories.join(", ")}.`;
  }

  return ""; 
};




export const validateGSTNumber = (gstNumber) => {
  if (!gstNumber) return ""; 

  const trimmedGst = gstNumber.trim(); 
  const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[A-Z0-9]{1}$/;

  if (trimmedGst.length !== 15) {
    return "GST number must be exactly 15 characters long.";
  }

  if (!regex.test(trimmedGst)) {
    return "Invalid GST number format. The format should be: 2-digit state code, PAN (AAAAA9999A), entity code, 'Z', and a checksum.";
  }

  // Extract components for additional validation
  const stateCode = trimmedGst.substring(0, 2);
  const panSection = trimmedGst.substring(2, 12);
  const entityCode = trimmedGst[12];
  const defaultZ = trimmedGst[13];

  // Check if the state code is valid (01 to 37)
  const validStateCodes = [
    "01", "02", "03", "04", "05", "06", "07", "08", "09", "10",
    "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
    "21", "22", "23", "24", "25", "26", "27", "28", "29", "30",
    "31", "32", "33", "34", "35", "36", "37"
  ];

  if (!validStateCodes.includes(stateCode)) {
    return "Invalid state code in GST number. It should be a valid Indian state code (01-37).";
  }

  // Validate PAN format (inside GST)
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  if (!panRegex.test(panSection)) {
    return "Invalid PAN format in GST number. It should follow the format AAAAA9999A.";
  }

  // Entity code should be a digit (0-9)
  if (!/^[0-9]$/.test(entityCode)) {
    return "Invalid entity code in GST number. The 13th character should be a digit (0-9).";
  }

  // Default character should always be 'Z'
  if (defaultZ !== "Z") {
    return "Invalid GST number. The 14th character must always be 'Z'.";
  }

  return ""; // Valid GST Number
};



//for driving license
export const validateDrivingLicense = (license) => {
  const regex = /^[A-Z]{2}-\d{2}-\d{7,8}$/; // Driving License format: SS-YY-NNNNNNNN

  if (!license) {
    return "Driving License number is required.";
  }

  if (!regex.test(license)) {
    return "Enter a valid Driving License number (e.g., MH-20-2022012345).";
  }

  return "";
};

export const validateExperience = (experience) => {
  const regex = /^[0-9]+$/; // Only numbers allowed for experience (in years)

  if (!experience) {
    return "Experience is required.";
  }

  if (!regex.test(experience)) {
    return "Experience must be a number.";
  }

  return "";
};
export const validateTextalone = (text) => {
  if (!text) {
    return "This field is required.";
  }
  const containsInvalidCharsRegex = /[^a-zA-Z ]/;
  if (containsInvalidCharsRegex.test(text)) {
    return "Text must contain only letters and spaces.";
  }

  if (!/[a-zA-Z]/.test(text)) {
    return "Text must contain at least one letter.";
  }

  return "";
};


export const validateFile = (file, allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'], maxSizeMB = 2) => {
  if (!file) {
      return { valid: false, error: 'No file selected.' };
  }

  if (!allowedTypes.includes(file.type)) {
      return { valid: false, error: 'Invalid file type. Please upload a JPEG or PNG image.' };
  }

  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  if (file.size > maxSizeBytes) {
      return { valid: false, error: `File size exceeds ${maxSizeMB}MB. Please upload a smaller file.` };
  }

  return { valid: true, error: '' };
};



export const validateProduct = (input) => {
  const errors = {};

  // Product Name Validation (Non-empty and Length Check)
  if (!input.product_name) {
    errors.product_name = "Product Name is required.";
  } else if (input.product_name.length < 3) {
    errors.product_name = "Product Name must be at least 3 characters long.";
  }

  // SKU Validation (Non-empty and Length Check)
  if (!input.sku) {
    errors.sku = "SKU is required.";
  } else if (input.sku.length < 5) {
    errors.sku = "SKU must be at least 5 characters long.";
  }

  // Price Validation (Greater than 0)
  if (input.price <= 0) {
    errors.price = "Price must be greater than 0.";
  } else if (isNaN(input.price)) {
    errors.price = "Price must be a valid number.";
  }

  // Stock Quantity Validation (Non-negative and Integer Check)
  if (input.stock_quantity <= 0) {
    errors.stock_quantity = "Stock Quantity must be greater than 0.";
  } else if (isNaN(input.stock_quantity)) {
    errors.stock_quantity = "Stock Quantity must be a valid number.";
  }

  // Dealer Price Validation (Greater than or Equal to Zero and Can be Disabled)
  if (input.dealer_price < 0) {
    errors.dealer_price = "Dealer Price can't be negative.";
  } else if (input.dealer_price && isNaN(input.dealer_price)) {
    errors.dealer_price = "Dealer Price must be a valid number.";
  }

  // Discount Validation (Percentage Value Between 0 and 100)
  if (input.discount < 0 || input.discount > 100) {
    errors.discount = "Discount must be between 0 and 100.";
  } else if (isNaN(input.discount)) {
    errors.discount = "Discount must be a valid number.";
  }

  // GST Type Validation (Required Selection)
  if (!input.gst_type) {
    errors.gst_type = "Please select a GST Type.";
  }

  // GST Percentage Validation (Between 0 and 100)
  if (input.gst_percentage < 0 || input.gst_percentage > 100) {
    errors.gst_percentage = "GST Percentage must be between 0 and 100.";
  } else if (isNaN(input.gst_percentage)) {
    errors.gst_percentage = "GST Percentage must be a valid number.";
  }

  // Keywords Validation (Non-empty Array)
  if (!Array.isArray(input.keywords) || input.keywords.length === 0) {
    errors.keywords = "Please enter at least one keyword.";
  }

  // Parent Category Validation (Required Selection)
  if (!input.category_name) {
    errors.category_name = "Parent category is required.";
  }

  // Description Validation (Optional but Length Check)
  if (input.description && input.description.length < 10) {
    errors.description = "Description must be at least 10 characters long.";
  }
 
  return errors;
};

// validateSpecifications.js
export const validateSpecifications = (specifications) => {
  const errors = specifications.map(() => ({ title: "", desc: "" }));

  if (!specifications || specifications.length === 0) {
    return [{ title: "At least one specification is required.", desc: "" }];
  }

  specifications.forEach((spec, index) => {
    if (!spec.title || spec.title.length < 3) {
      errors[index].title = `Title must be at least 3 characters long.`;
    }
    if (!spec.desc || spec.desc.length < 5) {
      errors[index].desc = `Description must be at least 5 characters long.`;
    }
  });

  return errors;
};

export const validateFiles = (files, type) => {
  const errors = [];
  const maxImages = 5;
  const maxVideos = 2;
  const maxImageSize = 2 * 1024 * 1024; // 2MB
  const maxVideoSize = 5 * 1024 * 1024; // 5MB

  if (type === "image") {
    if (files.length > maxImages) {
      errors.push(`You can upload a maximum of ${maxImages} images.`);
    }
    files.forEach((file) => {
      if (file.size > maxImageSize) {
        errors.push(`${file.name} must be less than 2MB.`);
      }
    });
  }

  if (type === "video") {
    if (files.length > maxVideos) {
      errors.push(`You can upload a maximum of ${maxVideos} videos.`);
    }
    files.forEach((file) => {
      if (file.size > maxVideoSize) {
        errors.push(`${file.name} must be less than 5MB.`);
      }
    });
  }

  return errors;
};


export const validateEmails = (email) => {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !pattern.test(email) ? "Invalid email format" : "";
};

/*---------------------------------------------------------------------------------------------------------------------------------------*/

// Optional validation versions of required fields

export const validateBusinessNameOptional = (value) => {
  const businessNameRegex = /^[a-zA-Z0-9\s]{3,}$/;
  if (!value.trim()) return "";
  if (!businessNameRegex.test(value)) {
    return "Business Name must be at least 3 characters and contain only letters, numbers, and spaces.";
  }
  return "";
};

export const validateBusinessCategoryOptional = (value) => {
  return "";
};

export const validateBusinessNameOthersOptional = (value) => {
  const regex = /^[a-zA-Z0-9\s]{3,}$/;
  if (!value.trim()) return "";
  if (!regex.test(value)) {
    return "Custom Business Name must be at least 3 characters and contain only letters, numbers, and spaces.";
  }
  return "";
};

export const validateOwnerNameOptional = (value) => {
  const regex = /^[a-zA-Z0-9\s]{3,}$/;
  if (!value.trim()) return "";
  if (!regex.test(value)) {
    return "Name must be at least 3 characters and contain only letters, numbers, and spaces.";
  }
  return "";
};

export const validateNameOptional = (name) => {
  const trimmedName = name.trim();
  const regex = /^[a-zA-Z]+(?: [a-zA-Z]+)*$/;
  if (!trimmedName) return "";
  if (trimmedName.length < 2) return "Name must be at least 2 characters long.";
  if (trimmedName.length > 50) return "Name must not exceed 50 characters.";
  if (!regex.test(trimmedName)) return "Name can only contain letters and single spaces. No numbers or special characters allowed.";
  return "";
};

export const validateMobileNumberOptional = (value) => {
  if (!value) return "";
  if (!/^\d+$/.test(value)) return "Mobile number must contain only digits.";
  if (value.length !== 10) return "Mobile number must be exactly 10 digits.";
  if (!/^[6-9]\d{9}$/.test(value)) return "Enter a valid 10-digit mobile number.";
  return "";
};

export const validateEmailOptional = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) return "";
  if (!regex.test(email)) return "Enter a valid email address.";
  return "";
};

export const validatePasswordOptional = (password) => {
  if (!password) return "";
  if (password.length < 8) return "Password must be at least 8 characters long.";
  if (!/[A-Z]/.test(password)) return "Password must contain at least one uppercase letter.";
  if (!/[a-z]/.test(password)) return "Password must contain at least one lowercase letter.";
  if (!/[0-9]/.test(password)) return "Password must contain at least one number.";
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return "Password must contain at least one special character.";
  return "";
};

export const validateOtpOptional = (otp) => {
  if (!otp) return "";
  if (!/^\d{6}$/.test(otp)) return "OTP must be exactly 6 digits.";
  return "";
};

export const validateBankAccountNumberOptional = (accountNumber) => {
  const trimmed = accountNumber.trim();
  if (!trimmed) return "";
  if (!/^\d+$/.test(trimmed)) return "Bank account number must contain only digits.";
  if (trimmed.length < 9 || trimmed.length > 18) return "Bank account number must be between 9 and 18 digits.";
  return "";
};

export const validateIFSCCodeOptional = (code) => {
  const trimmed = code.trim();
  if (!trimmed) return "";
  if (trimmed.length !== 11) return "IFSC code must be exactly 11 characters long.";
  if (!/^[A-Z]{4}/.test(trimmed)) return "First 4 characters must be uppercase letters.";
  if (trimmed[4] !== "0") return "The 5th character must be '0'.";
  if (!/^[A-Z0-9]{6}$/.test(trimmed.slice(5))) return "Last 6 characters must be uppercase letters or digits.";
  return "";
};

export const validatePanCardNumberOptional = (pan) => {
  const trimmed = pan.trim();
  if (!trimmed) return "";
  const regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  if (trimmed.length !== 10) return "PAN card number must be exactly 10 characters long.";
  if (!regex.test(trimmed)) return "PAN card number must be in the format AAAAA9999A.";
  const validCategories = ["P", "C", "H", "F", "A", "T", "B", "L", "J", "G"];
  if (!validCategories.includes(trimmed[3])) return `Invalid PAN type. The 4th character should be one of ${validCategories.join(", ")}.`;
  return "";
};

export const validateAadharNumberOptional = (aadhar) => {
  const regex = /^\d{4}-\d{4}-\d{4}$/;
  if (!aadhar) return "";
  if (!regex.test(aadhar)) return "Aadhar number must be in the format xxxx-xxxx-xxxx.";
  return "";
};

export const validateDrivingLicenseOptional = (license) => {
  const regex = /^[A-Z]{2}-\d{2}-\d{7,8}$/;
  if (!license) return "";
  if (!regex.test(license)) return "Enter a valid Driving License number (e.g., MH-20-2022012345).";
  return "";
};

export const validateTextaloneOptional = (text) => {
  if (!text) return "";
  if (/\d/.test(text)) return "Text should not contain numbers.";
  return "";
};

export const validateExperienceOptional = (experience) => {
  const regex = /^[0-9]+$/;
  if (!experience) return "";
  if (!regex.test(experience)) return "Experience must be a number.";
  return "";
};


export const validateServiceType = (values) => {
  return Array.isArray(values) && values.length > 0 ? "" : "Please select at least one service type.";
};

export const validateSpecializations = (values) => {
  return Array.isArray(values) && values.length > 0 ? "" : "Please select at least one specialization.";
};


export const validateOperatingLocation = (value) => {
  if (!value.trim()) return "Shop / Work Address is required.";
  if (value.trim().length < 10) return "Please enter a valid address with pincode.";
  return "";
};

export const validateHomeAddress = (value) => {
  if (!value.trim()) return "Home Address is required.";
  if (value.trim().length < 10) return "Please enter a valid home address with pincode.";
  return "";
};


export const validateDetails = (value) => {
  if (!value.trim()) return "Details are required.";
  if (value.trim().length < 15) return "Please provide a detailed description of your services.";
  return "";
};
